import { render, staticRenderFns } from "./TableHorariosLab.vue?vue&type=template&id=6603c8a4&scoped=true&"
import script from "./TableHorariosLab.vue?vue&type=script&lang=js&"
export * from "./TableHorariosLab.vue?vue&type=script&lang=js&"
import style0 from "./TableHorariosLab.vue?vue&type=style&index=0&id=6603c8a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6603c8a4",
  null
  
)

export default component.exports